import React, { useContext, useState, useEffect, useMemo, } from "react";
import { TextField, Button, Box, Typography, Grid, Drawer, Badge } from "@mui/material";
import { CustomSelect, SnackSimple } from "../../../../../../../../components";
import { useStyles } from "./styles";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useGetData } from "../../hooks/useGetData";
import { FormContext } from "../../Context";
import { ObjectGeneric, onChangeEvent } from "../../../../../../../../utils/types/generals";
import { UploadEvidence } from "../../../../../../../../components/uploadEvidence";
import { Category, FormattedCategory, EvidenceState, evidence, EvidencesFormat } from "../../Interfaces";
import { useNavigate } from "react-router-dom";
import { RequestErrors, Roles, Types } from "../../../../../../../../utils/enums";
import { ConfirmModal } from "../ConfirmModal";
import { useTranslation } from "react-i18next";
import MultiSelectSimple from "../../../../../../../../components/dinamicForm/multiSelectSimple";
import { getLocalStorage, LocaleNameType } from "../../../../../../../../utils/crud/crypt";
import { icons } from "../../../../../../../../utils/icons";
import { EvidenceGeneralConfig } from "../../../../../../../../components/uploadEvidence/types";
import { LoadingButton } from "@mui/lab";
import { handleAllErrors } from "../../../../../../../../utils/methods/handleErrors";
import { Priority } from "../../../../../../../../utils/enums/priority";
import { EvidencesTypeValueEnum } from "../../../../../../../../utils/enums/evidences";


export const Step2 = ({ onBack }: { onBack: () => void }) => {
  const navigate = useNavigate();
  const { t } = useTranslation()
  const { unitys, getProvidersForUnit, providers, config, createFolio, editFolio } = useGetData();
  const state: { isManagerOfDeparment: boolean, role: number } = getLocalStorage(LocaleNameType.STATE)
  const isManagerOfDepartment = state?.isManagerOfDeparment
  const isAdmin = state?.role === Roles.ADMIN
  const { formData, updateFormData, id } = useContext(FormContext);
  const [snackMessage, setSnackMessage] = useState("");
  const [snackType, setSnackType] = useState<Types>(Types.SUCCESS);
  const [selectedUnit, setSelectedUnit] = useState<ObjectGeneric | null>(formData.selectedUnit || null);
  const [selectedPriority, setSelectedPriority] = useState(formData.selectedPriority || null);
  const [selectedProvider, setSelectedProvider] = useState<ObjectGeneric | null>(formData.selectedProvider || null);
  const [title, setTitle] = useState(formData.title || "");
  const [description, setDescription] = useState(formData.description || "");
  const [manager, setManager] = useState<string>("");
  const [availablePriorities, setAvailablePriorities] = useState<any[]>([]);
  const [openUploadEvidence, setOpenUploadEvidence] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [flag, setFlaf] = useState(formData.flagStep2 ?? true)
  const [evidencesDrawer, setEvidencesDrawer] = useState<EvidencesFormat>(formData.evidences ?? {
    open: false,
    type: {
      equivalence: [],
      accept: '',
    },
  })
  const [titleError, setTitleError] = useState<string | null>(null);
  const [descriptionError, setDescriptionError] = useState<string | null>(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [evidencesRequiredAreLoad, setEvidencesRequiredAreLoad] = useState<Record<string, boolean>>({});
  const [requiredEvidencesValid, setRequiredEvidencesValid] = useState(false);
  const [localProviders, setLocalProviders] = useState<any[]>([]);
  const [subcategoryProvider, setSubcategoryProvider] = useState<any>(null);
  const styles = useStyles();
  const priorityOptions = [
    { id: '4', value: Priority.URGENT, label: t('catalog.priority.4') },
    { id: '1', value: Priority.HIGH, label: t('catalog.priority.1') },
    { id: '2', value: Priority.MEDIUM, label: t('catalog.priority.2') },
    { id: '3', value: Priority.LOW, label: t('catalog.priority.3') }
  ];

  const PRIORITY_WEIGHT: Record<number, number> = {
    4: 1,
    1: 2,
    2: 3,
    3: 4,
  };

  const isPriorityOne = (priority: any): boolean => {
    if (!priority) return false;
    return Number(priority) === Priority.HIGH || Number(priority.value) === Priority.HIGH || Number(priority) === Priority.URGENT || Number(priority.value) === Priority.URGENT;
  };

  // Función para obtener todas las prioridades únicas de las categorías seleccionadas
  const getUniquePriorities = () => {
    if (isManagerOfDepartment || isAdmin) {
      return priorityOptions;
    }

    const priorities = new Set();
    const priorityMap = new Map();

    if (formData.selectedSubcategories) {
      formData.selectedSubcategories.forEach((selectedSub: any) => {
        formData.categories.forEach((category: any) => {
          const subcategory = category.subcategories.find(
            (sub: any) => sub.id === selectedSub.id
          );
          if (subcategory?.priority) {
            priorities.add(subcategory.priority.id);
            priorityMap.set(subcategory.priority.id, {
              label: subcategory.priority.name,
              value: subcategory.priority.id.toString()
            });
          }
        });
      });
      return Array.from(priorities).map(id => priorityMap.get(id));
    }
    return [];
  };


  // Función para obtener la prioridad más alta
  const getHighestPriority = () => {
    let highestPriority = null;
    let lowestPriorityId = Infinity; // Menor ID = mayor prioridad

    if (formData.selectedSubcategories) {
      formData.selectedSubcategories.forEach((selectedSub: any) => {
        formData.categories.forEach((category: any) => {
          const subcategory = category.subcategories.find(
            (sub: any) => sub.id === selectedSub.id
          );
          if (subcategory?.priority && subcategory.priority.id < lowestPriorityId) {
            lowestPriorityId = subcategory.priority.id;
            highestPriority = subcategory.priority.id.toString();
          }
        });
      });

      return highestPriority;
    } else {
      return null
    }

  };

  const getHighestProvider = () => {
    let highestPriority = null;
    let lowestPriorityId = Infinity; // Menor ID = mayor prioridad
    let provider = null;

    if (formData.selectedSubcategories) {
      formData.selectedSubcategories.forEach((selectedSub: any) => {
        formData.categories.forEach((category: any) => {
          const subcategory = category.subcategories.find(
            (sub: any) => sub.id === selectedSub.id
          );
          if (subcategory?.user && PRIORITY_WEIGHT[subcategory.priority.id] < lowestPriorityId) {
            lowestPriorityId = PRIORITY_WEIGHT[subcategory.priority.id];
            highestPriority = subcategory.priority.id.toString();
            provider = { label: `${subcategory.user.firstName} ${subcategory.user.lastName}`, value: subcategory.user.id }
          }
        });
      });

      return provider;
    } else {
      return null
    }

  };

  useEffect(() => {
    const priorities = getUniquePriorities();
    const provider = getHighestProvider();
    setAvailablePriorities(priorities);
    
    if(id) return;

    // Reset priority when subcategories change
    if (formData.selectedSubcategories) {
      const highestPriority = getHighestPriority();
      if (highestPriority /* && !id */) {
        setSelectedPriority(highestPriority);
        if (provider) {
          setSelectedProvider(provider)
        }
        updateFormData({
          ...formData,
          selectedPriority: highestPriority,
          selectedProvider: /* !selectedProvider ? */ provider ? provider : formData.selectedProvider
        });
      }

    }
  }, [formData.selectedSubcategories]);

  const handleUnitChange = async (e: onChangeEvent) => {
    const unitId = e.target.value;
    if (!unitId) {
      setSelectedUnit(null);
      setManager("");
      if (!isPriorityOne(selectedPriority)) {
        setSelectedProvider(null);
        setLocalProviders([]);
        updateFormData({
          ...formData,
          selectedUnit: null,
          selectedProvider: null
        });
      } else {
        const existsProvidder = Number(subcategoryProvider.value) === Number(formData.selectedProviderCopy?.value);

        if (!existsProvidder && !!id && !!formData.selectedProviderCopy?.value) {
          setLocalProviders([subcategoryProvider, formData.selectedProviderCopy]);
        } else {
          setLocalProviders([subcategoryProvider]); // Mantiene el estado igual si ya existe
        }
      }
      return;
    }

    setSelectedUnit(unitId);

    if (formData.department?.value) {
      await getProvidersForUnit(unitId.value, formData.department.value);
      updateProvidersList(providers);
    }

    updateFormData({
      ...formData,
      selectedUnit: unitId,
      selectedProvider: selectedProvider
    });
  };

  useEffect(() => {
    if (selectedUnit?.value && formData.department?.value) {
      getProvidersForUnit(selectedUnit.value, formData.department.value);
    }
  }, []);


  useEffect(() => {
    if (selectedUnit) {
      const selectedUnityData = unitys.find(unit => unit.value === Number(selectedUnit.value));
      if (selectedUnityData?.extraData?.user) {
        const { firstName, lastName } = selectedUnityData.extraData.user;
        setManager(`${firstName} ${lastName}`);
      } else {
        setManager("No hay un encargado asociado a esta unidad");
      }
    } else {
      setManager("");
    }
  }, [selectedUnit, unitys]);

  const handlePriorityChange = (e: onChangeEvent) => {
    const priorityId = e.target.value;
    setSelectedPriority(priorityId);

    if (selectedUnit?.value && formData.department?.value) {
      getProvidersForUnit(selectedUnit.value, formData.department.value)
        .then(() => {
          if (isPriorityOne(priorityId) && subcategoryProvider) {
            // Para prioridad 1, incluir subcategoryProvider y providers normales
            const normalProviders = providers.filter(p => p.value !== subcategoryProvider.value);
            const updatedProviders = [subcategoryProvider, ...normalProviders];

            const existsProvidder = updatedProviders.some((provider: any) => Number(provider.value) === Number(formData.selectedProviderCopy?.value));
            if (!existsProvidder && !!id && !!formData.selectedProviderCopy?.value) {
              setLocalProviders([...updatedProviders, formData.selectedProviderCopy]);
            } else {
              setLocalProviders([...updatedProviders]); // Mantiene el estado igual si ya existe
            }
            setSelectedProvider(subcategoryProvider);
            updateFormData({
              ...formData,
              selectedPriority: priorityId,
              selectedProvider: subcategoryProvider
            });
          } else {
            // Para otras prioridades, SOLO providers normales, explícitamente excluir subcategoryProvider
            const normalProviders = providers.filter(p =>
              !subcategoryProvider || p.value !== subcategoryProvider.value
            );

            const existsProvidder = normalProviders.some((provider: any) => Number(provider.value) === Number(formData.selectedProviderCopy?.value));
            if (!existsProvidder && !!id && !!formData.selectedProviderCopy?.value) {
              setLocalProviders([...normalProviders, formData.selectedProviderCopy]);
            } else {
              setLocalProviders([...normalProviders]); // Mantiene el estado igual si ya existe
            }
            setSelectedProvider(null);
            updateFormData({
              ...formData,
              selectedPriority: priorityId,
              selectedProvider: null
            });
          }
        });
    } else {
      if (isPriorityOne(priorityId) && subcategoryProvider) {
        const existsProvidder = Number(subcategoryProvider.value) === Number(formData.selectedProviderCopy?.value);
        if (!existsProvidder && !!id && !!formData.selectedProviderCopy?.value) { //acaaa
          setLocalProviders([subcategoryProvider, formData.selectedProviderCopy]);
        } else {
          setLocalProviders([subcategoryProvider]); // Mantiene el estado igual si ya existe
        }
        setSelectedProvider(subcategoryProvider);
        updateFormData({
          ...formData,
          selectedPriority: priorityId,
          selectedProvider: subcategoryProvider
        });
      } else {
        setLocalProviders([]);
        setSelectedProvider(null);
        updateFormData({
          ...formData,
          selectedPriority: priorityId,
          selectedProvider: null
        });
      }
    }
  };

  const handleProviderChange = (e: onChangeEvent) => {
    const providerId = e.target.value;
    setSelectedProvider(providerId);
    updateFormData({
      ...formData,
      selectedProvider: providerId
    });
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTitle = e.target.value;
    setTitle(newTitle);

    if (newTitle.trim().length < 3) {
      setTitleError("Debe tener al menos 3 caracteres");
    } else {
      updateFormData({
        ...formData,
        title: newTitle
      });
      setTitleError(null);
    }
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDescription = e.target.value;
    setDescription(newDescription);

    if (newDescription.trim().length < 3) {
      setDescriptionError("Debe tener al menos 3 caracteres");
    } else {
      updateFormData({
        ...formData,
        description: newDescription
      });
      setDescriptionError(null);
    }
  };

  const handleAttachDocument = () => {
    setOpenUploadEvidence(true);
    setEvidencesDrawer(prev => ({
      ...prev,
      open: true
    }));
  };

  const handleCloseUpload = () => {
    setOpenUploadEvidence(false);
    setEvidencesDrawer(prev => ({
      ...prev,
      open: false
    }));
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    updateFormData({
      ...formData,
      evidences: evidencesDrawer
    });
  }, [evidencesDrawer]);

  const validateRequiredEvidences = useMemo(() => {
    if (!evidencesDrawer.value) return false;

    return Object.entries(evidencesDrawer.value).every(([_, typeData]) => {
      if (!typeData.required) return true;

      const filesCount = Object.keys(typeData.value || {}).length;
      return filesCount >= (typeData.minAmount || 1);
    });
  }, [evidencesDrawer.value]);

  useEffect(() => {
    setRequiredEvidencesValid(validateRequiredEvidences);
  }, [validateRequiredEvidences]);

  const createEvidenceTypes = config?.configActionPlanReportFolioEvidenceTypes?.filter(
    (item: EvidenceGeneralConfig) => item.type === 'CREATE'
  );

  const isRequired = !!(
    Array.isArray(createEvidenceTypes) &&
    createEvidenceTypes.some((item: EvidenceGeneralConfig) => item.required === true)
  );

  const hasEvidenceConfig = Array.isArray(createEvidenceTypes) && createEvidenceTypes.length > 0;

  /* const isRequired = !!(config?.configActionPlanReportFolioEvidenceTypes && Array.isArray(config.configActionPlanReportFolioEvidenceTypes) && config.configActionPlanReportFolioEvidenceTypes.some((item: EvidenceGeneralConfig) => item.required === true));
  const hasEvidenceConfig = config?.configActionPlanReportFolioEvidenceTypes?.length > 0; */

  const isFormValid = selectedUnit &&
    title &&
    title.trim().length >= 3 &&
    description &&
    description.trim().length >= 3 &&
    //Si es urgente o alta debe tener proveedor
    //( ( Number(selectedPriority?.value || selectedPriority) == Priority.URGENT || Number(selectedPriority?.value || selectedPriority) == Priority.HIGH ) && selectedProvider ) &&
    /* (Number(selectedPriority?.value || selectedPriority) == Priority.URGENT ||
      (Number(selectedPriority?.value || selectedPriority) == Priority.HIGH)
      ? selectedProvider
      : true
    ) && */
    (!hasEvidenceConfig || requiredEvidencesValid);

  const formatCategories = (
    categories: Category[],
    selectedSubcategories: Subcategory[],
    formData: any,
    categoriesCopy?: Category[],
  ): FormattedCategory[] => {
    const formattedCategories: FormattedCategory[] = [];

    const flattenDropList = (list: DropListSubCategorie[], result: DropListSubCategorie[] = []): DropListSubCategorie[] => {
      for (const item of list) {
        result.push(item);
        if (item.dropList && item.dropList.length > 0) {
          flattenDropList(item.dropList, result);
        }
      }
      return result;
    };

    categories.forEach(category => {
      category.subcategories.forEach(subcategory => {

        const matches = selectedSubcategories.filter(sel => sel.id === subcategory.id);

        matches.forEach(sel => {
          const allDropItems = flattenDropList(sel.dropList);

          const configAnswer = allDropItems.map((item, index) => ({
            currentNode: item.currentNode ?? 0,
            id: item.value,
            name: item.label,
          }));

          formattedCategories.push({
            categoryId: category.id,
            category: category.name,
            subcategoryId: subcategory.id,
            subcategory: subcategory.name,
            priorityId: subcategory.priority.id,
            priority: subcategory.priority.name,
            requestText: subcategory.requestText,
            listText: sel.textRequest ?? '',
            userAssignId: subcategory.user?.id || null,
            configAnswer,
            versionDropDownsLinksId: subcategory.version ?? undefined,
            idArray: sel.idArray
          });
        });
      });
    });

    const existingSubcategoryKeys = new Set(
      formattedCategories.map(fc => `${fc.subcategoryId}-${fc.idArray ?? 0}`)
    );

    if (!!id) {
      categoriesCopy?.forEach(category => {
        category.subcategories.forEach(subcategory => {
          const matches = selectedSubcategories.filter(sel => sel.id === subcategory.id);

          matches.forEach(sel => {
            const allDropItems = flattenDropList(sel.dropList);

            const configAnswer = allDropItems.map((item, index) => ({
              currentNode: item.currentNode ?? 0,
              id: item.value,
              name: item.label,
            }));

            const key = `${subcategory.id}-${sel.idArray ?? 0}`;

            if (!existingSubcategoryKeys.has(key)) {
              formattedCategories.push({
                categoryId: category.id,
                category: category.name,
                subcategoryId: subcategory.id,
                subcategory: subcategory.name,
                priorityId: subcategory.priority.id,
                priority: subcategory.priority.name,
                requestText: subcategory.requestText,
                listText: sel.textRequest ?? '',
                userAssignId: subcategory.user?.id || null,
                configAnswer,
                versionDropDownsLinksId: sel.version ?? subcategory.version ?? undefined,
              });

              existingSubcategoryKeys.add(key);
            }
          });
        });
      });
    }

    return formattedCategories.map(({ idArray, ...rest }) => rest);
  };

  const handleSubmit = async () => {
    const evidences: evidence[] = [];
    const comments: string[] = [];

    const formattedCategories = formatCategories(
      formData.categories,
      formData.selectedSubcategories ?? [],
      formData,
      formData.categoriesCopy,
    );

    if (evidencesDrawer.value) {
      Object.entries(evidencesDrawer.value).forEach(([typeId, typeData]) => {
        if (typeData.value) {
          Object.values(typeData.value).forEach(file => {
            if (file.url && Number(typeId) !== EvidencesTypeValueEnum.COMMENT && Number(typeId) !== EvidencesTypeValueEnum.OBSERVATION_COMMENT) {
              evidences.push({
                url: file.url,
                originalname: file.name,
                evidenceTypeId: typeId,
              });
            }
            if ((Number(typeId) === EvidencesTypeValueEnum.OBSERVATION_COMMENT || Number(typeId) === EvidencesTypeValueEnum.COMMENT) && file.url) {
              comments.push(String(file.url));
            }
          });
        }
      });
    }

    const submitData = !id ? {
      reportFolios: [
        {
          areaId: Number(formData.area?.id),
          departmentId: Number(formData.department?.value),
          storeId: Number(selectedUnit?.value),
          priorityId: Number(selectedPriority?.value || selectedPriority),
          userAssignId: selectedProvider?.value,
          name: title,
          description,
          evidences,
          comments,
          categories: formattedCategories,
          type: "corrective",
        },
      ],
    } :
      {
        areaId: Number(formData.area?.id),
        departmentId: Number(formData.department?.value),
        storeId: Number(selectedUnit?.value),
        priorityId: Number(selectedPriority?.value || selectedPriority),
        userAssignId: selectedProvider?.value,
        name: title,
        description,
        evidences,
        comments,
        categories: formattedCategories,
        type: "corrective",
      };

    setIsSubmitting(true);
    try {
      if (!id) {
        const response: any = await createFolio(submitData);
        //@ts-ignore
        if (response.errors || response.code === RequestErrors.ERR_DUPLICATE_FOLIO || response.code === RequestErrors.VALIDATION_ERROR || response.code == RequestErrors.ERR_NOT_HAVE_CONFIGURATION) {
          //@ts-ignore
          const isLimit = response.code == RequestErrors.ERR_NOT_HAVE_CONFIGURATION ? response.data[0].error ? true : false : false;
          const duplicatedFolios: string = isLimit ? handleAllErrors(RequestErrors.ERR_LIMIT_EXCEEDED, t) : handleAllErrors(response?.code, t);
          setSnackbarOpen(true);
          setSnackMessage(duplicatedFolios);
          setSnackType(Types.ERROR);
        } else {
          setSnackMessage("Folio creado exitosamente");
          setSnackType(Types.SUCCESS);
          setSnackbarOpen(true);
          setTimeout(() => {
            navigate("/dashboard/report-folio/dashboard");
          }, 2000);
        }
      } else {
        const response = await editFolio(submitData, Number(id));
        //@ts-ignore

        if (response.code === RequestErrors.VALIDATION_ERROR || response.code === RequestErrors.ERR_NOT_FOUND || response.code === RequestErrors.ERR_NOT_ALLOWED || response.code === RequestErrors.ERR_UNAUTHORIZED) {
          //@ts-ignore
          const duplicatedFolios: string = handleAllErrors(response?.code, t);
          setSnackbarOpen(true);
          setSnackMessage(duplicatedFolios);
          setSnackType(Types.ERROR);
        } else {
          setSnackMessage("Folio editado exitosamente");
          setSnackType(Types.SUCCESS);
          setSnackbarOpen(true);
          setTimeout(() => {
            navigate("/dashboard/report-folio/dashboard");
          }, 2000);
        }
      }
    } catch (error) {
      setSnackMessage("Error al crear el folio");
      setSnackType(Types.ERROR);
      setSnackbarOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  const getSubcategoryProvider = () => {
    /* const subcategoryWithUser = formData.selectedSubcategories?.find(
      (sub: any) => sub.user
    ); */
    const subcategoryWithUser = formData.selectedSubcategories?.[0];
    if (subcategoryWithUser?.user) {
      return {
        label: subcategoryWithUser.user?.label,
        value: subcategoryWithUser.user?.id,
        extraData: { id: subcategoryWithUser.user?.id }
      };
    }
    return null;
  };


  const updateProvidersList = (newProviders: any[]) => {
    if (isPriorityOne(selectedPriority) && subcategoryProvider) {
      // Para prioridad 1, incluir subcategoryProvider y providers normales
      const normalProviders = newProviders.filter(p => p.value !== subcategoryProvider.value);
      const updatedProviders = [subcategoryProvider, ...normalProviders];

      const existsProvidder = updatedProviders.some((provider: any) => Number(provider.value) === Number(formData.selectedProviderCopy?.value));
      if (!existsProvidder && !!id && !!formData.selectedProviderCopy?.value) {
        setLocalProviders([...updatedProviders, formData.selectedProviderCopy]);
      } else {
        setLocalProviders([...updatedProviders]); // Mantiene el estado igual si ya existe
      }
      if (!selectedProvider) {
        setSelectedProvider(subcategoryProvider);
        updateFormData({
          ...formData,
          selectedProvider: subcategoryProvider
        });
      }
    } else {
      // Para otras prioridades, SOLO providers normales
      const normalProviders = newProviders.filter(p =>
        !subcategoryProvider || p.value !== subcategoryProvider.value
      );
      const existsProvidder = normalProviders.some((provider: any) => Number(provider.value) === Number(formData.selectedProviderCopy?.value));
      if (!existsProvidder && !!id && !!formData.selectedProviderCopy?.value) {
        setLocalProviders([...normalProviders, formData.selectedProviderCopy]);
      } else {
        setLocalProviders([...normalProviders]); // Mantiene el estado igual si ya existe
      }
    }
  };
  useEffect(() => {
    if (formData.selectedProvider) {
      setSelectedProvider(formData.selectedProvider);
    }

    if (providers.length > 0) {
      if (isPriorityOne(selectedPriority) && subcategoryProvider) {
        // Para prioridad 1, incluir subcategoryProvider y providers normales
        const normalProviders = providers.filter(p => p.value !== subcategoryProvider.value);
        const updatedProviders = [subcategoryProvider, ...normalProviders];

        const existsProvidder = updatedProviders.some((provider: any) => Number(provider.value) === Number(formData.selectedProviderCopy?.value));
        if (!existsProvidder && !!id && !!formData.selectedProviderCopy?.value) {
          setLocalProviders([...updatedProviders, formData.selectedProviderCopy]);
        } else {
          setLocalProviders([...updatedProviders]); // Mantiene el estado igual si ya existe
        }

        if (!selectedProvider) {
          setSelectedProvider(subcategoryProvider);
          updateFormData({
            ...formData,
            selectedProvider: subcategoryProvider
          });
        }
      } else {
        // Para otras prioridades, SOLO providers normales
        const normalProviders = providers.filter(p =>
          !subcategoryProvider || p.value !== subcategoryProvider.value
        );
        const existsProvidder = normalProviders.some((provider: any) => Number(provider.value) === Number(formData.selectedProviderCopy?.value));
        if (!existsProvidder && !!id && !!formData.selectedProviderCopy?.value) {
          setLocalProviders([...normalProviders, formData.selectedProviderCopy]);
        } else {
          setLocalProviders([...normalProviders]); // Mantiene el estado igual si ya existe
        }
      }
    } else if (isPriorityOne(selectedPriority) && subcategoryProvider) {

      const existsProvidder = Number(subcategoryProvider.value) === Number(formData.selectedProviderCopy?.value);
      if (!existsProvidder && !!id && !!formData.selectedProviderCopy?.value) {
        setLocalProviders([subcategoryProvider, formData.selectedProviderCopy]);
      } else {
        setLocalProviders([subcategoryProvider]); // Mantiene el estado igual si ya existe
      }
      if (!selectedProvider) {
        setSelectedProvider(subcategoryProvider);
        updateFormData({
          ...formData,
          selectedProvider: subcategoryProvider
        });
      }
    } else {
      setLocalProviders([]);
    }
  }, [providers, subcategoryProvider, selectedPriority]);

  useEffect(() => {
    if (selectedUnit?.value && formData.department?.value) {
      getProvidersForUnit(selectedUnit.value, formData.department.value)
        .then(() => {
          if (isPriorityOne(selectedPriority) && subcategoryProvider) {
            // Para prioridad 1, incluir subcategoryProvider y providers normales
            const normalProviders = providers.filter(p => p.value !== subcategoryProvider.value);
            const updatedProviders = [subcategoryProvider, ...normalProviders];
            const existsProvidder = updatedProviders.some((provider: any) => Number(provider.value) === Number(formData.selectedProviderCopy?.value));
            if (!existsProvidder && !!id && !!formData.selectedProviderCopy?.value) {
              setLocalProviders([...updatedProviders, formData.selectedProviderCopy]);
            } else {
              setLocalProviders([...updatedProviders]); // Mantiene el estado igual si ya existe
            }

          } else {
            // Para otras prioridades, SOLO providers normales
            const normalProviders = providers.filter(p =>
              !subcategoryProvider || p.value !== subcategoryProvider.value
            );
            const existsProvidder = normalProviders.some((provider: any) => Number(provider.value) === Number(formData.selectedProviderCopy?.value));
            if (!existsProvidder && !!id && !!formData.selectedProviderCopy?.value) {
              setLocalProviders([...normalProviders, formData.selectedProviderCopy]);
            } else {
              setLocalProviders([...normalProviders]); // Mantiene el estado igual si ya existe
            }

          }
        });
    }
  }, [selectedUnit, formData.department, selectedPriority]);

  useEffect(() => {
    const provider = getSubcategoryProvider();
    setSubcategoryProvider(provider);
  }, [formData.selectedSubcategories, selectedPriority]);

  const shouldShowBadge = useMemo(() => {
    if (!evidencesDrawer.value || !isRequired) return false;

    return Object.entries(evidencesDrawer.value).some(([_, typeData]) => {
      if (!typeData.required) return false;
      const filesCount = Object.keys(typeData.value || {}).length;
      return filesCount < (typeData.minAmount || 1);
    });
  }, [evidencesDrawer.value, isRequired]);


  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xl={5} sm={12}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Asignar unidad
                </Typography>
                <MultiSelectSimple
                  errors={null}
                  name="Unidad"
                  label={"Unidad *"}
                  onChange={handleUnitChange}
                  items={unitys}
                  selected={selectedUnit}
                />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Encargado
                </Typography>
                <Typography
                  sx={{
                    color: manager.includes("No hay") ? "text.secondary" : "text.primary",
                    fontStyle: manager.includes("No hay") ? "italic" : "normal"
                  }}
                >
                  {manager}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Asignar prioridad
                </Typography>
                <MultiSelectSimple
                  isRequired
                  errors={null}
                  name="Prioridad"
                  label={"Prioridad *"}
                  onChange={handlePriorityChange}
                  items={availablePriorities}
                  selected={selectedPriority}
                  disabled={!isManagerOfDepartment && !isAdmin}
                />
              </Box>
            </Grid>

            {(isManagerOfDepartment || isAdmin) ? (
              <Grid item xs={6}>
                <Box>
                  <Typography variant="subtitle2" gutterBottom>
                    Asignar proveedor
                  </Typography>
                  <MultiSelectSimple
                    isRequired
                    errors={null}
                    name="Proveedor"
                    label={"Proveedor"}
                    onChange={handleProviderChange}
                    items={localProviders ?? []}
                    selected={selectedProvider}
                    disabled={(!selectedUnit || !formData.department) || (!isManagerOfDepartment && !isAdmin)}
                  />
                </Box>
              </Grid>
            ) : <>
            </>
            }

          </Grid>
        </Grid>

        <Grid item xl={7} sm={12}>
          <Grid container spacing={2}>
            <Grid item xl={10} sm={10}>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Solicitud
                </Typography>
                <TextField
                  fullWidth
                  required
                  label="Título"
                  placeholder="Escriba el título de la solicitud"
                  value={title}
                  onChange={handleTitleChange}
                  error={!!titleError}
                  helperText={titleError}
                  inputProps={{ maxLength: 45 }}
                />
              </Box>
            </Grid>

            <Grid item xl={2} sm={2}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
                sx={{
                  marginTop: 1,
                }}
              >
                {shouldShowBadge ? (
                  <Badge sx={styles.badge(isRequired)} badgeContent={icons('priorityHigh')}>
                    <Button
                      variant="contained"
                      onClick={handleAttachDocument}
                      sx={styles.button}
                      disabled={!hasEvidenceConfig}
                    >
                      <AttachFileIcon />
                    </Button>
                  </Badge>
                ) : (
                  <Button
                    variant="contained"
                    onClick={handleAttachDocument}
                    sx={styles.button}
                    disabled={!hasEvidenceConfig}
                  >
                    <AttachFileIcon />
                  </Button>
                )}
              </Box>
            </Grid>

            <Grid item xl={12} sm={12}>
              <Box>
                <TextField
                  fullWidth
                  required
                  label="Descripción"
                  placeholder="Descripción de la solicitud..."
                  multiline
                  rows={4}
                  value={description}
                  onChange={handleDescriptionChange}
                  error={!!descriptionError}
                  helperText={descriptionError}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <SnackSimple
        open={snackbarOpen}
        close={handleCloseSnackbar}
        message={snackMessage}
        type={snackType}
      />

      <Drawer
        anchor="right"
        open={evidencesDrawer.open}
        onClose={handleCloseUpload}
        PaperProps={{
          sx: {
            width: "30%", // Ajusta el ancho del Drawer a tu necesidad
          },
        }}
      >
        <Box p={2} sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
          <Typography variant="h6" gutterBottom>
            Evidencias
          </Typography>

          {/* Aquí incluirías el componente UploadEvidence */}
          {openUploadEvidence && (
            <UploadEvidence
              uploadName="Report-folio-corrective"
              evidencesDrawer={evidencesDrawer as EvidenceState} // Hacemos el cast aquí
              evidencesRequiredAreLoad={evidencesRequiredAreLoad}
              showRequireds={false}
              setEvidencesDrawer={setEvidencesDrawer}
              setEvidencesRequiredAreLoad={setEvidencesRequiredAreLoad}
              close={handleCloseUpload}
            />
          )}
        </Box>
      </Drawer>

      <Box display="flex" justifyContent="space-between" width="100%" sx={{
        marginTop: {
          sm: 10,
          xl: 30
        }
      }}>
        <Button
          onClick={onBack}
          sx={{
            textTransform: "none",
            padding: 0,
            backgroundColor: "transparent",
            color: "primary.main",
            "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
          }}
        >
          Regresar
        </Button>
        <LoadingButton
          variant="contained"
          loading={isSubmitting}
          disabled={!isFormValid}
          sx={{ borderRadius: '4px' }}
          onClick={() => setConfirmModalOpen(true)}
        >
          {!id ? 'Crear solicitud' : 'Editar solicitud'}
        </LoadingButton>
      </Box>

      <ConfirmModal
        open={confirmModalOpen}
        onClose={() => !isSubmitting && setConfirmModalOpen(false)}
        onConfirm={handleSubmit}
        title={!id ? "Creación de folio" : "Edición de folio"}
        description={!id ? "¿Estás seguro que deseas crear este folio correctivo?" : "¿Estás seguro que deseas editar este folio correctivo?"}
        loading={isSubmitting}
      />
    </Box>
  );
};